export default __webpack_public_path__ + "static/step-enjoy-9bb7f7171473c674a08f30004b71cf1b.png";